import { Component } from '@theme/component';

/* Visual feedback only. Native cart transport, availability and counters remain authoritative. */
class FlyToCart extends Component {
  source;
  destination;
  useSourceSize = false;
  #animation;

  connectedCallback() {
    super.connectedCallback();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || navigator.connection?.saveData || document.visibilityState === 'hidden' || typeof this.animate !== 'function') {
      this.remove(); return;
    }
    const visible = element => {
      if (!element?.isConnected || !element.getClientRects().length) return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth && getComputedStyle(element).visibility !== 'hidden';
    };
    let destination = this.destination;
    if (window.matchMedia('(max-width:749px)').matches) {
      const cart = Array.from(document.querySelectorAll('[data-veyro-bottom-nav] [data-nav-cart],.veyro-mobile-nav [data-veyro-nav-cart]')).find(visible);
      if (cart) destination = cart.querySelector('svg') || cart;
    }
    if (!visible(destination)) destination = Array.from(document.querySelectorAll('.header-actions__cart-icon')).find(visible);
    if (!visible(this.source) || !visible(destination)) { this.remove(); return; }
    const start = this.source.getBoundingClientRect(), end = destination.getBoundingClientRect();
    const size = Math.min(this.useSourceSize ? Math.max(start.width, start.height) : 56, 96);
    const x = start.left + start.width / 2, y = start.top + start.height / 2;
    const dx = end.left + end.width / 2 - x, dy = end.top + end.height / 2 - y;
    Object.assign(this.style, { position:'fixed', left:`${x - size / 2}px`, top:`${y - size / 2}px`, width:`${size}px`, height:`${size}px`, margin:'0', pointerEvents:'none', zIndex:'2147483000', borderRadius:'12px', backgroundSize:'contain', backgroundRepeat:'no-repeat', backgroundPosition:'center', backgroundColor:'#f7f6f3', animation:'none', opacity:'1', offsetPath:'none' });
    this.#animation = this.animate([
      { transform:'translate(0,0) scale(1)', opacity:.95 },
      { transform:`translate(${dx * .5}px,${dy * .5 - 36}px) scale(.68)`, opacity:.85, offset:.5 },
      { transform:`translate(${dx}px,${dy}px) scale(.12)`, opacity:0 }
    ], { duration:520, easing:'cubic-bezier(.2,.6,.3,1)', fill:'forwards' });
    this.#animation.finished.catch(() => {}).finally(() => this.remove());
  }

  disconnectedCallback() {
    this.#animation?.cancel();
    super.disconnectedCallback();
  }
}
if (!customElements.get('fly-to-cart')) customElements.define('fly-to-cart', FlyToCart);
